/**
 * Roles Table Header Component
 *
 * Shared header component for roles table.
 * Displays column labels for role name, users count, and actions.
 *
 * @module domains/personnel/presentation/components/list/RolesTableHeader
 */

import { useTranslation } from 'react-i18next';

/**
 * Roles Table Header Component
 *
 * Renders the table header with column labels.
 * Shared between RolesTable and RolesTableSkeleton.
 *
 * @returns {React.ReactElement} Table header component
 *
 * @example
 * <RolesTableHeader />
 */
const styles = {
  container: 'bg-muted border-b border-border flex items-center px-2 w-full',
  column: 'flex-1 px-2 py-3',
  columnRight: 'flex-1 px-2 py-3 text-right',
  label: 'text-sm font-medium text-muted-foreground',
};

export const RolesTableHeader = (): React.ReactElement => {
  const { t } = useTranslation('roles');

  return (
    <div className={styles.container}>
      <div className={styles.column}>
        <p className={styles.label}>{t('list.table.columns.role')}</p>
      </div>
      <div className={styles.columnRight}>
        <p className={styles.label}>{t('list.table.columns.usersCount')}</p>
      </div>
      <div className={styles.columnRight}>
        <p className={styles.label}>{t('list.table.columns.actions')}</p>
      </div>
    </div>
  );
};
